import Component from './TwitterPostFilter.vue'
export default Component
